<script>
  import * as THREE from "three";
  // import Stats from "stats.js";
  import { scaleLinear } from "d3";
  import { onMount, setContext } from "svelte";
  import {
    time,
    mode,
    progress,
    scrollZ,
    activePlanet,
    showPopup,
    tip,
    abouted,
  } from "../stores/global.js";
  import viewport from "../stores/viewport.js";
  import Planets from "./Universe.Planets.svelte";
  import Starfields from "./Universe.Starfields.svelte";
  import fx from "../utils/fx.js";

  export let pointerX = 0;
  export let pointerY = 0;

  export const click = () => onClick();

  const DEPTH = 10000;
  const FOV = 1;
  const NEAR = DEPTH * 0.005;
  const FAR = DEPTH * 0.5;
  const RADIUS = DEPTH * 0.00003;
  const COLOR_BG = new THREE.Color(0x000000);
  const SCROLL_MIN = 0;
  const SCROLL_MAX = DEPTH;
  const PIXEL_RATIO =
    typeof window === "undefined" ? 2 : Math.max(window.devicePixelRatio, 2);
  const CAMERA = new THREE.PerspectiveCamera(FOV, 1, NEAR, FAR);
  const raycaster = new THREE.Raycaster();
  const pointer = new THREE.Vector2(0, 0);
  const clock = new THREE.Clock();
  const group = new THREE.Group();

  let canvas;
  let renderer;
  let scene;
  let controls;
  let mounted;
  let planetGroup;

  setContext("Universe", {
    CAMERA,
    FOV,
    DEPTH,
    NEAR,
    FAR,
    RADIUS,
    PIXEL_RATIO,
  });

  $: scaleDepth = scaleLinear().range([SCROLL_MIN, SCROLL_MAX]);
  $: $viewport.width, $viewport.height, onResize();
  $: $scrollZ = scaleDepth($progress);
  $: pointerX, pointerY, updatePointer();
  $: group.position.z = $scrollZ;

  const onClick = () => {
    if ($activePlanet !== undefined) {
      $showPopup = $activePlanet;
      fx("pop");
    }
  };

  const calcScreenCoords = (obj) => {
    let pos = new THREE.Vector3();
    pos = pos.setFromMatrixPosition(obj.matrixWorld);
    pos.project(CAMERA);

    const widthHalf = $viewport.width / 2;
    const heightHalf = $viewport.height / 2;

    pos.x = pos.x * widthHalf + widthHalf;
    pos.y = -(pos.y * heightHalf) + heightHalf;

    $tip.x = pos.x;
    $tip.y = pos.y;
    // const vFOV = (CAMERA.fov * Math.PI) / 180;
    // const z = DEPTH - NEAR - (obj.position.z + group.position.z);
    // const dist = CAMERA.position.distanceTo(new THREE.Vector3(0, 0, z));

    // const vFOV = THREE.MathUtils.degToRad(CAMERA.fov);
    // const height = 2 * Math.tan(vFOV / 2) * dist;
    // const width = height * CAMERA.aspect;
  };
  const updatePointer = () => {
    if (!mounted) return;
    pointer.set(pointerX, pointerY);
    raycaster.setFromCamera(pointer, CAMERA);
    // const meshes = planetGroup.children.map((c) => c.children[0].children[0]);
    const meshes = planetGroup.children.map(
      (c) => c.children[1].children[0].children[1]
    );

    const intersects = raycaster.intersectObjects(meshes);
    let best;
    // if (intersects.length) console.log(intersects[0].object.material.opacity);

    if (intersects.length && intersects[0].object.material.opacity >= 0.7)
      best = intersects[0];

    // console.log(best, $activePlanet);

    if (best) {
      const { index } = best.object.userData;
      $activePlanet = index;
      calcScreenCoords(best.object.parent.parent.parent);
    } else if ($activePlanet !== "undefined") {
      $activePlanet = undefined;
    }
  };

  const onResize = () => {
    if (!mounted) return;
    CAMERA.aspect = $viewport.width / $viewport.height;
    CAMERA.updateProjectionMatrix();
    renderer.setSize($viewport.width, $viewport.height);
  };

  const tick = () => {
    // stats.begin();

    $time += clock.getDelta();
    renderer.render(scene, CAMERA);

    // stats.end();
    window.requestAnimationFrame(tick);
  };

  onMount(() => {
    // stats = new Stats();
    // stats.showPanel(0);
    // document.body.appendChild(stats.dom);

    CAMERA.position.z = DEPTH;
    scene = new THREE.Scene();
    scene.background = COLOR_BG;
    scene.fog = new THREE.Fog(COLOR_BG, 1, FAR / 3);
    scene.add(CAMERA);
    scene.add(group);

    const light = new THREE.AmbientLight(0xffffff); // soft white light
    scene.add(light);
    renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: true,
      powerPreference: "high-performance",
    });
    renderer.setPixelRatio(PIXEL_RATIO);
    mounted = true;
    $scrollZ = NEAR + 1;
    onResize();
    tick();
  });
</script>

<canvas
  bind:this="{canvas}"
  class:is-active="{$mode === 'explore' && !$abouted}"></canvas>

{#if mounted}
  <Planets group="{group}" bind:planetGroup />
  <Starfields group="{group}" />
{/if}

<style>
  canvas {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    outline: none;
    pointer-events: none;
    filter: blur(8px);
    transition: filter 500ms ease-in;
  }

  canvas.is-active {
    filter: none;
  }
</style>
